import { render } from "./i-chevron.vue?vue&type=template&id=0234d9c8"
import script from "./i-chevron.vue?vue&type=script&lang=js"
export * from "./i-chevron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__